module.exports = __webpack_public_path__ + "static/media/8.74fd19ad.jpg";